import { Box, Button, Typography } from '@mui/material'
import React from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import StateComponents from '../../../components/state-component/StateComponents';
import { room_meeting_type_data } from '../../../constants/enum';
import { useManageStateDetail } from './manageStateDetail';
import { routeName } from '../../../routes/routeName';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import EditNoteIcon from '@mui/icons-material/EditNote';
import StepperCustom from '../../../components/step/Stepper';
import ListClassrooms from './element/ListClassrooms';
import OtherDetail from './element/OtherDetail';
import { useNavigate, useParams } from 'react-router-dom';
import ItemsDetail from './element/ItemsDetail';
import RoomMeetingService from '../../cms/booking-room-management/components/RoomMeetingService';
import { BOOKING_MEETING_ROOM, booking_meeting_room_status } from './enum';
import ItemsInClassrooms from './element/ItemsInClassrooms';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import PaymentBookingMeetingRoom from './element/PaymentBookingMeetingRoom';
import { BankAccountTypeOptions } from '../../cms/course-online/manage-payment-channel/enum/manage_payment';
import StatusCustom from '../../../components/status/statusCustom';
import MeetingRoomContact from './element/MeetingRoomContact';
import CalendarActivityDetail from './element/CalendarActivityDetail';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';

type Props = {
    view?: boolean;
    is_personal?: boolean;
}

const ClassroomMeetingBookingDetail: React.FC<Props> = ({ view, is_personal }: Props) => {
    const navigate = useNavigate();
    const { id } = useParams();

    const {
        pathname,
        room_meeting_type,
        set_room_meeting_type,
        step,
        set_step,
        setSelectedId,
        selectedId,
        formState,
        setFormState,
        error_message,
        handleSubmit,
        clearErrorMessage,
        check_error_field,
        handleDownloadFile,
        handleConfirmBookingMeetingRoom,
        select_bank,
        payment_channel_data,
        remark,
        uploadMultiFilePromise,

    } = useManageStateDetail({ is_personal });


    const disabled_draft_button = (): boolean => {
        let is_not_valid: boolean = false;
        if (step === 0 && (!room_meeting_type || !selectedId)) {
            is_not_valid = true
        }
        return is_not_valid
    }
    const disabled_next_button = (): boolean => {
        let is_not_valid: boolean = false;
        if (step == 0 && !room_meeting_type) {
            is_not_valid = true;
        }
        if (step == 0 && !selectedId) {
            is_not_valid = true;
        }
        if (step == 1 && !check_error_field.is_valid) {
            is_not_valid = true;
        }
        return is_not_valid
    }

    const can_edit = [BOOKING_MEETING_ROOM.DRAFT].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
    const view_status: boolean = [
        BOOKING_MEETING_ROOM.WAITING_PAYMENT,
        BOOKING_MEETING_ROOM.WAITING_CONFIRM_PAYMENT,
        BOOKING_MEETING_ROOM.RECHECK_PAYMENT,
        BOOKING_MEETING_ROOM.CONFIRM_BOOKING,
        BOOKING_MEETING_ROOM.REJECT_BOOKING
    ].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
    const hidden_step_one: boolean = [
        BOOKING_MEETING_ROOM.WAITING_PAYMENT,
        BOOKING_MEETING_ROOM.WAITING_CONFIRM_PAYMENT,
        BOOKING_MEETING_ROOM.CONFIRM_BOOKING,
        BOOKING_MEETING_ROOM.RECHECK_PAYMENT,
        BOOKING_MEETING_ROOM.REJECT_BOOKING].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
    const show_payment: boolean = [
        BOOKING_MEETING_ROOM.WAITING_PAYMENT,
        BOOKING_MEETING_ROOM.WAITING_CONFIRM_PAYMENT,
        BOOKING_MEETING_ROOM.CONFIRM_BOOKING,
        BOOKING_MEETING_ROOM.RECHECK_PAYMENT,
        BOOKING_MEETING_ROOM.REJECT_BOOKING].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
    const disabled_payment: boolean = [
        BOOKING_MEETING_ROOM.WAITING_CONFIRM_PAYMENT,
        BOOKING_MEETING_ROOM.CONFIRM_BOOKING,
        BOOKING_MEETING_ROOM.REJECT_BOOKING].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
    const show_status = [
        BOOKING_MEETING_ROOM.REJECT_BOOKING,].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
    const show_remark = [
        BOOKING_MEETING_ROOM.RECHECK_PAYMENT,
        BOOKING_MEETING_ROOM.CONFIRM_BOOKING,
    ].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);
    const show_cancel_booking_and_show_other_data = [
        BOOKING_MEETING_ROOM.CONFIRM_BOOKING,
    ].includes(formState.meeting_room_status as BOOKING_MEETING_ROOM);


    console.log(view, 'view')
    return (
        <Box className="w-full min-h-screen px-4 py-4 md:px-20 md:py-5">
            <ContainerLayout
                title='ทำเรื่องขอจอง'
                hidden_sub_title={!show_status}
                sub_title_custom={(show_status || show_remark) ? (
                    <Box my={1} className="flex justify-start items-center">
                        <StatusCustom
                            text={booking_meeting_room_status?.find((x) => x.value == formState.meeting_room_status)?.label || ""}
                            type={booking_meeting_room_status?.find((x) => x.value == formState.meeting_room_status)?.label || ""}
                            disableMaxWidth
                            sx={{ maxWidth: "fit-content", px: 2 }}
                        />
                        {show_remark && remark && (
                            <Typography sx={{ color: 'red' }}>
                                {remark}
                            </Typography>
                        )}
                    </Box>
                ) : undefined}
                navigateContent={
                    <NavigateListCustom
                        navigateData={[
                            {
                                key: "จองห้องเรียน/จองห้องประชุม",
                                name: "จองห้องเรียน/จองห้องประชุม",
                                pathName: is_personal ? routeName.cms.BookingRoom : routeName.public.classroom_meeting_booking
                            },
                            {
                                key: "ทำเรื่องขอจอง",
                                name: "ทำเรื่องขอจอง",
                                pathName: pathname
                            },
                        ]}
                    />
                }
                content={
                    <Box className="w-full">
                        <div className='max-w-fit m-auto'>
                            <StepperCustom
                                setStep={(st) => {
                                    if (!room_meeting_type && !selectedId) {
                                        return;
                                    }
                                    set_step(st);
                                }}
                                step={step}
                                view={view_status}
                                sx={{ maxWidth: "fit-content" }}
                                stepLabel={[
                                    ...(hidden_step_one ? [] : [
                                        {
                                            name: "เลือกห้อง",
                                            isAccept: true,
                                            disabled: disabled_next_button(),
                                        },
                                    ]),
                                    {
                                        name: "ระบุข้อมูลเพิ่มเติม",
                                        isAccept: disabled_next_button(),
                                        disabled: disabled_next_button(),
                                    },
                                    {
                                        name: view_status ? "ข้อมูลอุปกรณ์เพิ่มเติม" : "ระบุอุปกรณ์เพิ่มเติม",
                                        isAccept: check_error_field.is_valid,
                                        disabled: disabled_next_button(),
                                    },
                                    {
                                        name: view_status ? "บริการเพิ่มเติม" : "ระบุบริการเพิ่มเติม",
                                        isAccept: disabled_next_button(),
                                        disabled: disabled_next_button(),

                                    },
                                    ...(show_payment ? [
                                        {
                                            name: "ข้อมูลการชำระเงิน",
                                            isAccept: true,
                                            disabled: false,
                                            icon: <AccountBalanceWalletIcon />
                                        },
                                    ] : []),
                                    ...(show_cancel_booking_and_show_other_data ? [
                                        {
                                            name: "รายละเอียดการอนุมัติ",
                                            isAccept: true,
                                            disabled: false,
                                            icon: <CheckBoxIcon />
                                        },
                                        {
                                            name: "รายละเอียดการอนุมัติ",
                                            isAccept: true,
                                            disabled: false,
                                            icon: <CheckBoxOutlineBlankIcon />
                                        },
                                    ] : []),
                                ]}
                            />
                        </div>

                        {step === 0 && (
                            <StateComponents
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.label || "",
                                            labelId: "room_meeting_type_data",
                                            heading: "ประเภทห้อง",
                                            disabled: !!id,
                                            onChange: (_, val) => set_room_meeting_type(val ?? null),
                                            options: room_meeting_type_data,
                                            placeholder: "ระบุประเภทห้อง",
                                            value: room_meeting_type || null
                                        }
                                    }
                                ]}
                            />
                        )}
                        {room_meeting_type && step === (hidden_step_one ? 99 : 0) && (
                            <>
                                <ListClassrooms
                                    selectedId={selectedId}
                                    setSelectedId={setSelectedId}
                                    view={view}
                                    room_meeting_type={room_meeting_type?.value}
                                    id_room_meeting={selectedId || undefined}
                                />
                            </>
                        )}
                        {room_meeting_type && step === (hidden_step_one ? 0 : 1) && (
                            <>
                                <ItemsInClassrooms equipment={[]} files={[]} />
                                <OtherDetail
                                    formState={formState}
                                    setFormState={setFormState}
                                    errorMessage={error_message}
                                    clearErrorMessage={clearErrorMessage}
                                    disabled={view || view_status}
                                    handleDownloadFile={handleDownloadFile}
                                    is_personal={is_personal}
                                    hidden_detail_send_request={is_personal}
                                />
                            </>
                        )}
                        {room_meeting_type && step === (hidden_step_one ? 1 : 2) && id && selectedId && (
                            <>
                                <ItemsDetail
                                    view={(view || view_status)}
                                    id_room_meeting={selectedId}
                                    id_meeting_room={+id}
                                    is_personal={is_personal}
                                />
                            </>
                        )}
                        {room_meeting_type && step === (hidden_step_one ? 2 : 3) && id && selectedId && (
                            <>
                                <RoomMeetingService
                                    id_room_meeting={selectedId}
                                    id_meeting_room={+id}
                                    is_booking
                                    view={view || view_status}
                                    is_personal={is_personal}
                                />
                            </>
                        )}
                        {show_payment && step === 3 && id && (
                            <PaymentBookingMeetingRoom
                                id_meeting_room={+id}
                                payment_icon_url={select_bank?.icon || ""}
                                payment_name={payment_channel_data?.account_name_th || "-"}
                                payment_name_en={payment_channel_data?.account_name_eng || "-"}
                                payment_no={payment_channel_data?.account_no || "-"}
                                disabled={disabled_payment}
                                payment_type={BankAccountTypeOptions?.find((x) => x.value === payment_channel_data?.account_type)?.label || "-"}
                            />
                        )}
                        {show_cancel_booking_and_show_other_data && step === 4 && id && (
                            <MeetingRoomContact
                                id_meeting_room={+id}
                                uploadMultiFilePromise={uploadMultiFilePromise}
                                handleDownloadFile={handleDownloadFile}
                                view
                                show_cancel_booking
                            />
                        )}
                        {show_cancel_booking_and_show_other_data && step === 5 && id && (
                            <CalendarActivityDetail
                                id_meeting_room={+id}
                                uploadMultiFilePromise={uploadMultiFilePromise}
                                handleDownloadFile={handleDownloadFile}
                                view
                            />
                        )}


                        <Box my={4} className="w-full flex justify-center items-center gap-4">
                            {!show_payment && (
                                <Button onClick={() => {
                                    if (step < 1) {
                                        if (is_personal) {
                                            navigate(routeName.cms.BookingRoom)
                                        } else {
                                            navigate(routeName.public.classroom_meeting_booking)
                                        }
                                    } else {
                                        set_step((prev) => prev - 1)
                                    }
                                }} sx={{ borderRadius: "8px" }} variant='outlined'>ย้อนกลับ</Button>
                            )}
                            {!view && (
                                <>
                                    {step > 0 && !view_status && can_edit && (
                                        <Button
                                            disabled={disabled_draft_button()}
                                            startIcon={<EditNoteIcon />}
                                            sx={{ borderRadius: "8px" }}
                                            variant='contained'
                                            onClick={() => handleSubmit(true)}
                                        >
                                            บันทึกร่าง
                                        </Button>
                                    )}
                                </>
                            )}
                            {step == 3 && !show_payment && can_edit && !view && (
                                <Button
                                    sx={{ borderRadius: "8px" }}
                                    color='success'
                                    variant='contained'
                                    onClick={handleConfirmBookingMeetingRoom}
                                >
                                    ยืนยัน
                                </Button>
                            )}

                            {step < 3 && !view_status && (
                                <Button
                                    disabled={disabled_next_button()}
                                    endIcon={<NavigateNextIcon />}
                                    sx={{ borderRadius: "8px" }}
                                    color='success'
                                    variant='contained'
                                    onClick={() => {
                                        if (step == 1) {
                                            if (view) {
                                                set_step((prev) => prev + 1);
                                            } else {
                                                handleSubmit(true, true);
                                            }
                                        } else {
                                            set_step((prev) => prev + 1);
                                            window.scrollTo({ top: 0, behavior: 'smooth' })
                                        }
                                    }}
                                >
                                    ถัดไป
                                </Button>
                            )}
                        </Box>
                    </Box>
                }
            />
        </Box>
    )
}

export default ClassroomMeetingBookingDetail